import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'

const EMPLOYEE_URL = `${API_URL}/api/internal/employee`

export interface ProtectedAccount {
  userId: number
  /** Passkeys enrolled on top of the authenticator app. */
  passkeys: number
}

/** The accounts protected by a second factor. */
export const getProtectedAccounts = () =>
  axios.get<ApiResponse<{ userIds: number[]; accounts?: ProtectedAccount[] }>>(`${EMPLOYEE_URL}/second-factor/enabled`)

/** Removes an employee's authenticator app, passkeys and recovery codes. */
export const postResetSecondFactor = (id: number) =>
  axios.post<ApiResponse<{ wasEnabled: boolean }>>(`${EMPLOYEE_URL}/${id}/second-factor/reset`)
